/* eslint-disable */
<template>
    <div class="container-fluid mtb15 no-fluid">
        <div class="card mb-3 w-100">
            <img :src="placedIcon" class="card-img-top" alt="">
            <div class="card-body">
                <div class="card-text">
                <table class="table trade-confirmed-table w-100">
                    <tbody>
                        <tr v-for="row in tradeRows" :key="row.label">
                            <td>{{ row.label }}</td>
                            <td>{{ row.value }}</td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import I18n from "@/lang/i18n.js";
import UiUtils from "@/assets/js/ui_utils.js";
import { getStockTypeLabel } from "@/features/stocks/stock-type-labels";
import placedIcon from "@/assets/images/Placed.svg";

export default {
    props: {
        order: {
            required: true,
            type: Object
        }
    },
        methods: {
        t(key, ...args) {
            const language = typeof this.getUserLanguage === "function" ? this.getUserLanguage() : this.getUserLanguage;
            return I18n.t(key, language, ...args);
        },
        formatPrice(value) {
            return UiUtils.formatPrice(value, this.order?.currency, this.getUserLanguage, 2).replace(" ", "\u00A0");
        },
        formatNumber(value) {
            const numericValue = Number(value);
            return UiUtils.formatNumber(value, Number.isInteger(numericValue) ? 0 : 2);
        },
    },
    computed: {
        placedIcon() {
            return placedIcon;
        },
        getUserLanguage() {
            return this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN";
        },
        stockTypeLabels() {
            return {
                equities: this.t("equitiesLabel"),
                bonds: this.t("bondsLabel"),
                compInstruments: this.t("compInstrumentsLabel"),
                funds: this.t("fundsLabel"),
                reits: this.t("reitsLabel"),
                rights: this.t("rightsLabel"),
                cfd: this.t("cfdLabel"),
                margin: this.t("marginLabel"),
                netting: this.t("nettingLabel"),
                repo: this.t("repoLabel"),
                stocksAndEtfs: this.t("stocksAndEtfsLabel"),
                other: this.t("othersLabel"),
                unknown: this.t("othersLabel")
            };
        },
        instrumentTypeLabel() {
            return getStockTypeLabel(this.order?.stid, this.stockTypeLabels);
        },
        quantityLabel() {
            return 2 === parseInt(this.order?.stid)
                ? this.t("faceValueLabel")
                : this.t("quantityLabel");
        },
        tradeRows() {
            const rows = [
                { label: this.t("orderLabel"), value: `#${this.order?.oid || ""}` },
                { label: this.t("timestampLabel"), value: this.order?.time },
                { label: this.t("typeLabel"), value: this.order?.type },
                { label: this.t("codeLabel"), value: this.order?.code },
                { label: this.t("nameLabel"), value: this.order?.name },
                { label: this.t("exchangeLabel"), value: this.order?.ex }
            ];

            if (this.order?.stid) {
                rows.push({ label: this.t("instrumentTypeLabel"), value: this.instrumentTypeLabel });
            }

            rows.push(
                { label: this.quantityLabel, value: this.formatNumber(this.order?.amount) },
                { label: this.t("currencyLabel"), value: this.order?.currency },
                { label: this.t("priceLabel"), value: this.formatPrice(this.order?.price) },
                { label: this.t("amountLabel"), value: this.formatPrice(this.order?.price_total) },
                { label: this.t("commissionLabelLabel"), value: this.formatPrice(this.order?.fee) },
                { label: this.t("totalAmountLabel"), value: this.formatPrice(this.order?.total_amount) }
            );

            return rows;
        }
    }
}
</script>

<style scoped>
img {
    max-height: 5rem;
    max-width: auto;
}

.trade-confirmed-table td {
    border-bottom: 1px solid #eee;
    padding: 0.35rem 0.5rem;
    vertical-align: middle;
}

.trade-confirmed-table td:last-child {
    font-weight: 700;
    text-align: right;
}
</style>
